import script from "./CampoBuscaLista.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoBuscaLista.vue?vue&type=script&setup=true&lang=js"

import "./CampoBuscaLista.vue?vue&type=style&index=0&id=1a696b5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a696b5c"]])

export default __exports__